















import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import respStatus from '@/components/Resp/status.vue'
import Resp from '@/models/resp/Resp'
export default Vue.extend({
  props: {
    scope: {} as () => {resp: Resp},
    options: {}
  },
  components: {
    infoRowsBlock,
    respStatus
  },
  computed: {
    isDisabled (): boolean {
      return this.scope.resp.isFilled;
    }
  }
})
